export default "__VITE_ASSET__C_d3S8dh__"